import { createAction } from 'typesafe-actions';
import {
  ApiActionType,
  KeyComparer,
  KeyOnlyPayload,
  MainResourceHandler,
} from './types';

// This action is for deleting nested resources.
//    It will perform the operation purely in client side, and keep track of it.
//    When the parent resource is saved, this change will be sent alongside it.
export function createDeleteNestedAction<TItemKey, TItemSummary, TItemBody>(
  displayName: string,
  sameKey: KeyComparer<TItemKey, TItemSummary, TItemBody>,
) {
  const deleteNested = createAction(`@${displayName}/deleteNested`)<
    KeyOnlyPayload<TItemKey>
  >();

  const deleteNestedHandler: MainResourceHandler<
    TItemKey,
    TItemSummary,
    TItemBody,
    typeof deleteNested
  > = (state, action) => {
    const records = state.records.filter(
      r => !sameKey(action.payload.key, r.summary),
    );

    return {
      ...state,
      deletedKeys: [...state.deletedKeys, action.payload.key],
      records,
      currentItems: records.map(r => r.summary),
      lastRecordsChangedAction: ApiActionType.deleteNested,
    };
  };

  return {
    deleteNested,
    deleteNestedHandler,
  };
}
